import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const CurrencyHeaderViewer = (props) => {
    const { formObject } = props;

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Currency Detail' />
                    </span>
                </UiTitle>

                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyId" }} className="uiLbl" value="Currency ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currencyId" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyName" }} className="uiLbl" value="Currency Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currencyName" }} className="uiVal uiVal50p" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyShortName" }} className="uiLbl" value="Currency Short Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currencyShortName" }} className="uiVal uiVal50p" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencySymbol" }} className="uiLbl" value="Currency Symbol" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currencySymbol" }} className="uiVal uiVal50p" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyToWordTpl" }} className="uiLbl" value="To Word Template" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currencyToWordTpl" }} className="uiVal uiVal50p" />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(CurrencyHeaderViewer, "currencyHead", "");